'use client';

import { useQuery } from '@tanstack/react-query';

import Link from '@eliadmin/core/src/components/link';
import { IconButton } from '@eliadmin/core/src/components/nt/ui/icon-button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';
import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';

import { HEADER_BUTTON } from './header-ui';

/** Figma badge 7:8190 shows „999“ as its widest state. */
const MAX_COUNT = 999;

/**
 * Figma header „bag“ button: the core cart (React Query cache of `/store/cart`, as HeaderCartButton)
 * links to the cart page – core has no cart panel. The magenta badge counts the items.
 */
export function HeaderCart() {
  const systemLabels = useSystemLabels();
  const { data: cart } = useQuery(useCartQueryOpts());
  const count = cart?.count ?? 0;
  const label = systemLabels('cart');

  return (
    <span className="relative inline-flex shrink-0">
      <IconButton
        asChild
        icon="bag"
        label={count ? `${label} (${count})` : label}
        className={HEADER_BUTTON}
      >
        <Link href={ROUTES.CART() ?? '#'} />
      </IconButton>
      {count > 0 && (
        // Figma: 15 px left of the button's right edge; on phones anchored right so it stays inside
        // the 16 px page gutter.
        <span
          aria-hidden="true"
          className="nt-body-xs pointer-events-none absolute left-[calc(100%-15px)] top-[-9px] flex h-[18px] min-w-[18px] items-center justify-center rounded border-2 border-white bg-[#E5007E] px-1 text-white max-sm:left-auto max-sm:right-[-12px]"
        >
          {count > MAX_COUNT ? `${MAX_COUNT}+` : count}
        </span>
      )}
    </span>
  );
}
